<template>
  <div>
    <PageHeader
      :page="page"
      add-text="Anejar Documento"
      :has-add="allowAddDocument"
      has-return
      @onReturn="goBack"
      @onAdd="addDocument"
    />
    <!-- Section to add documents -->
    <div v-if="addingDocument">
      <SectionTitle
        bg-icon="green"
        icon="fas fa-file-plus"
        content="Añadir Documento"
        container-class="tag-badge-main-info mt-2 mb-2"
      />
      <ValidationObserver ref="formValidator">
        <div v-if="isForInterventionPlan" class="col-12 mt-4 pl-4">
          <div class="col-12 pt-0">
            <strong class="d-block">Proveedor:</strong>
            <span style="font-weight:100">{{ this.providerName }}</span>
          </div>
        </div>
        <div class="row gray-box row my-4 p-4 ml-1 align-items-start">
          <div
            v-if="isForInterventionPlan"
            class="col-md-3 col-4 col-xs-12 pt-0"
          >
            <ValidationProvider
              v-slot="{ errors }"
              name="Año Académico"
              rules="required"
            >
              <CustomDropDown
                v-model="selectedAcademicYearIP"
                label="Año Académico:"
                placeholder="Seleccionar"
                required
                fieldkey="id"
                fieldname="description"
                :options="academicYearListIP"
                :error="errors[0]"
                custom-error-msg="Favor de seleccionar el año académico."
                @input="onChangeAcademicYearIP"
              />
            </ValidationProvider>
          </div>
          <div v-if="isForInterventionPlan" class="col-md-3 col-4 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="Documento Plan Academico"
              rules="required"
            >
              <CustomDropDown
                v-model="selectedDocumentTypeIP"
                label="Documento:"
                placeholder="Seleccionar"
                fieldkey="id"
                fieldname="name"
                :options="documentTypeListIP"
                :error="errors[0]"
                custom-error-msg="Favor de seleccionar el tipo de documento."
                @input="onChangeDocumentIP"
              />
            </ValidationProvider>
          </div>
          <div v-if="!isForInterventionPlan" class="col-md-3 col-sm-12 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="Documento"
              rules="required"
            >
              <CustomDropDown
                v-model="selectedDocumentType"
                label="Documento:"
                placeholder="Seleccionar"
                required
                fieldkey="id"
                fieldname="name"
                :options="documentTypeList"
                :error="errors[0]"
                custom-error-msg="Favor de seleccionar el tipo de documento."
              />
            </ValidationProvider>
          </div>
          <div class="col-md-6 col-sm-12">
            <ValidationProvider
              v-slot="{ errors }"
              name="Archivo"
              rules="required"
            >
              <CustomFileInput
                ref="attachedDocument"
                v-model="selectedDocument"
                label="Archivo:"
                :accept="allowedFiles"
                required
                display-style="normal"
                label-position="left"
                :error="errors[0]"
                custom-error-msg="Favor de anejar el documento."
              />
            </ValidationProvider>
          </div>
          <div
            v-if="!isForInterventionPlan"
            class="col-md-3 col-sm-12 pt-0 buttons-container justify-content-end d-flex"
          >
            <ActionButton
              variant="outline-danger mr-2"
              i="fas fa-times-circle"
              min-width="124px"
              @click="cancelAddDocument"
            >
              Cancelar
            </ActionButton>
            <ActionButton
              variant="success"
              min-width="124px"
              @click="saveDocument"
            >
              Guardar
            </ActionButton>
          </div>
        </div>
        <div
          v-if="
            isForInterventionPlan &&
              selectedDocumentIpId &&
              selectedDocumentIpId !=
                thrpyDocumentTypesCodes.ResumenResultadoDeServicios
          "
          class="gray-box row my-4 p-4 ml-1 align-items-start mt-n3"
        >
          <div v-if="isBillingDiscussionPlanVisible" class="col-md-3">
            <ValidationProvider
              v-slot="{ errors }"
              name="Fecha del Plan"
              rules="required"
            >
              <div>
                <strong class="billing-text-label">
                  ¿Estará facturando la discusión del plan?
                </strong>
                <br />
                <span class="billing-text-span">
                  (Si no fue discutido con el padre marque NO)
                </span>
                <custom-radio-group
                  v-model="selectedbillingDiscussionIP"
                  name="billingDiscussionPlan"
                  :options="radioButtonsOptions"
                  :error="errors[0]"
                  custom-error-msg="Favor de seleccionar si el plan fue discutido con el encargado."
                  :is-inline="true"
                  @input="onSelectedBillingDisussionPlan"
                />
              </div>
            </ValidationProvider>
          </div>
          <div v-if="isDateAndTimeVisible" class="col-md-3">
            <ValidationProvider
              v-slot="{ errors }"
              name="Fecha del Plan"
              rules="required"
            >
              <custom-date-picker
                v-model="planDate"
                label="Fecha del Plan:"
                :error="errors[0]"
                :max-date="new Date()"
                :custom-error-msg="
                  'Favor de seleccionar la fecha de discusión.'
                "
              />
            </ValidationProvider>
          </div>
          <div v-if="isDateAndTimeVisible" class="col-md-3 col-sm-6">
            <div class="d-flex flex-row">
              <ValidationProvider
                v-slot="{ errors }"
                name="Hora"
                rules="required"
                class="mr-5"
              >
                <custom-time-picker
                  v-model="startTime"
                  label="Hora Desde:"
                  :error="errors[0]"
                  :custom-error-msg="
                    'Favor de seleccionar la hora desde de la discusión.'
                  "
                  @change="setStartTime"
                />
              </ValidationProvider>
              <ValidationProvider
                v-slot="{ errors }"
                name="Hora Hasta"
                rules="required"
              >
                <custom-time-picker
                  v-model="endTime"
                  label="Hora Hasta:"
                  :error="errors[0]"
                  :custom-error-msg="
                    'Favor de seleccionar la hora hasta de la discusión.'
                  "
                  @change="setEndTime"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div
          v-if="isForInterventionPlan"
          class="col-12 buttons-container justify-content-end d-flex"
        >
          <ActionButton
            variant="outline-danger mr-2"
            i="fas fa-times-circle"
            min-width="124px"
            @click="cancelAddDocument"
          >
            Cancelar
          </ActionButton>
          <ActionButton
            variant="success"
            min-width="124px"
            @click="saveDocument"
          >
            Guardar
          </ActionButton>
        </div>
      </ValidationObserver>
    </div>
    <div
      v-if="
        documentsCounter > 0 ||
          resultSummary != null ||
          achievementSummary != null
      "
    >
      <div
        v-for="item in academicYearIdList"
        :key="item.yearId"
        class="m-3 container-design"
      >
        <div class="w-100">
          <em
            v-if="!item.isOpen"
            class="fas fa-plus-circle rounded-circle shadow color-icon-plus custom-design"
            @click="item.isOpen = true"
          />
          <em
            v-else
            class="fas fa-minus-circle rounded-circle shadow text-orange custom-design"
            @click="item.isOpen = false"
          />
          <span class="pl-2">
            {{
              item.yearId != 0
                ? item.academicYearDescription
                : "Sin año academico"
            }}</span
          >
          <br />
        </div>
        <div v-if="item.isOpen" class="ml-4 mt-4">
          <div
            v-for="documentType in documentsByType"
            :key="documentType.id + documentType.name + item.yearId"
          >
            <div v-if="documentType.docs
            && existDocument(item.yearId, documentType.name, documentType.id)">
              <SectionTitle
                :bg-icon="
                  getBgIcon(
                    isTypeVisible(
                      documentType.id + documentType.name + item.yearId
                    )
                  )
                "
                class="cursor-pointer"
                :icon="
                  getIcon(
                    isTypeVisible(
                      documentType.id + documentType.name + item.yearId
                    )
                  )
                "
                :content="documentType.name"
                container-class="mt-2 mb-2"
                @on-click="
                  toggleVisibility(
                    documentType.id + documentType.name + item.yearId
                  )
                "
              />
              <transition name="list">
                <div
                  v-show="
                    isTypeVisible(
                      documentType.id + documentType.name + item.yearId
                    )
                  "
                  class="card-body p-0 mb-4"
                >
                  <div v-for="card in documentType.docs" :key="card.documentId">
                    <RowCardItemCard
                      status-class="gray"
                      :containerBgWhite="true"
                      v-if="card.academicYearId == item.yearId"
                    >
                      <!-- Cuerpo de la Card -->
                      <div slot="body">
                        <div class="col-12 p-0 d-flex">
                          <div
                            class="pl-0 py-0"
                            :class="{
                              'col-md-5 col-sm-12':
                                documentType.id ==
                                thrpyDocumentTypesCodes.PlanDeIntervencion,
                              'col-md-5 col-sm-12':
                                documentType.id !=
                                thrpyDocumentTypesCodes.PlanDeIntervencion
                            }"
                          >
                            <div class="d-flex flex-column">
                              <span class="data-title">Título:</span>
                              <span class="data-content">
                                {{ card.documentTitle }}
                              </span>
                            </div>
                          </div>
                          <div
                            v-if="
                              documentType.id ==
                                thrpyDocumentTypesCodes.PlanDeIntervencion
                            "
                            class=" ml-5 d-flex align-items-start flex-fill"
                          >
                            <div class="d-flex flex-column">
                              <span class="data-title">
                                ¿Estará facturando la discusión del plan?
                              </span>
                              <span class="data-content">
                                {{
                                  card.planDiscussedWithParentsFlag
                                    ? "SI"
                                    : "NO"
                                }}
                              </span>
                            </div>
                          </div>
                          <div
                            v-if="card.planProductionDate"
                            class="d-flex align-items-start flex-fill"
                          >
                            <div class="d-flex flex-column">
                              <span class="data-title">Fecha de Plan:</span>
                              <span class="data-content">
                                {{ card.planProductionDate | dateFormat }}
                              </span>
                            </div>
                          </div>
                          <div
                            v-if="card.completeTime"
                            class="d-flex align-items-start flex-fill"
                          >
                            <div class="d-flex flex-column">
                              <span class="data-title">Hora:</span>
                              <span class="data-content ml-1 cursor-pointer">
                                {{ card.completeTime }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div slot="actions">
                        <div class="dropdown text-right">
                          <button
                            class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <span class="px-2">Acciones</span>
                            <i class="fa fa-angle-down" />
                          </button>
                          <div
                            class="dropdown-menu dropdown-menu-right py-2 mt-1"
                          >
                            <div
                              class="dropdown-item"
                              @click="downloadDocument(documentType.id, card)"
                            >
                              <em class="fa fa-download text-green pr-1" />
                              <span>Descargar Documento</span>
                            </div>
                            <div
                              v-if="
                                hasReplaceDocPermission && canReplaceDoc(card)
                              "
                              class="dropdown-item"
                              @click="replaceDocument(card)"
                            >
                              <em class="fa fa-copy text-green pr-1" />
                              <span>Reemplazar Documento</span>
                            </div>
                            <div
                              v-if="
                                (isInterventionPlanDoc(card) &&
                                  interventionPlanDocs.length > 1 &&
                                  canBeDeleted(card)) ||
                                  canBeDeleted(card)
                              "
                              class="dropdown-item"
                              @click="
                                deleteDocument(
                                  card,
                                  documentType.id + documentType.name
                                )
                              "
                            >
                              <em class="fa fa-trash text-red pr-1" />
                              <span>Eliminar Documento</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </RowCardItemCard>
                  </div>
                  <div
                    v-if="
                      !existDocument(
                        item.yearId,
                        documentType.name,
                        documentType.id
                      )
                    "
                  >
                    <div
                      class="d-flex align-items-center justify-content-center mt-5 py-5"
                    >
                      <div class="align-items-center d-flex">
                        <i
                          class="fal big-icon mr-4 fa-folder-open text-gray-light"
                        />
                        <span class="text-gray-light message">
                          No existen documentos
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <!-- Resumen de Logros -->
          <div v-if="achievementSummary">
            <section-title
              :bg-icon="getBgIcon(isTypeVisible('achievementSummary'))"
              class="cursor-pointer"
              :icon="getIcon(isTypeVisible('achievementSummary'))"
              content="Resumen de Logros"
              container-class="mt-2 mb-2"
              @on-click="toggleVisibility('achievementSummary')"
            />
            <transition name="list">
              <div
                v-show="isTypeVisible('achievementSummary')"
                class="card-body p-0 mb-4"
              >
                <div>
                  <row-card-item-card
                    status-class="gray"
                    :containerBgWhite="true"

                  >
                    <div slot="body">
                      <div class="col-12 p-0 d-flex">
                        <div class="pl-0 py-0 col-5">
                          <div class="d-flex flex-column">
                            <span class="data-title">Título:</span>
                            <span class="data-content">
                              Resumen de Logros
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="actions">
                      <div class="dropdown text-right">
                        <button
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                          data-toggle="dropdown"
                        >
                          <span class="px-2">Acciones</span>
                          <i class="fa fa-angle-down" />
                        </button>
                        <div
                          class="dropdown-menu dropdown-menu-right py-2 mt-1"
                        >
                          <div
                            class="dropdown-item"
                            @click="downloadDocument('achievementSummary')"
                          >
                            <em class="fa fa-download text-green pr-1" />
                            <span>Descargar Documento</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </row-card-item-card>
                  <div
                    v-for="documentType in summaryAchievements"
                    :key="documentType.id + documentType.name + item.yearId"
                  >
                    <div
                      v-for="card in documentType.docs"
                      :key="card.documentId"
                    >
                      <RowCardItemCard
                        status-class="gray"
                        :containerBgWhite="true"
                        v-if="card.academicYearId == item.yearId"
                      >
                        <!-- Cuerpo de la Card -->
                        <div slot="body">
                          <div class="col-12 p-0 d-flex">
                            <div
                              class="pl-0 py-0"
                              :class="{
                                'col-md-5 col-sm-12':
                                  documentType.id ==
                                  thrpyDocumentTypesCodes.PlanDeIntervencion,
                                'col-md-5 col-sm-12':
                                  documentType.id !=
                                  thrpyDocumentTypesCodes.PlanDeIntervencion
                              }"
                            >
                              <div class="d-flex flex-column">
                                <span class="data-title">Título:</span>
                                <span class="data-content">
                                  {{ card.documentTitle }}
                                </span>
                              </div>
                            </div>
                            <div
                              v-if="
                                documentType.id ==
                                  thrpyDocumentTypesCodes.PlanDeIntervencion
                              "
                              class=" ml-5 d-flex align-items-start flex-fill"
                            >
                              <div class="d-flex flex-column">
                                <span class="data-title">
                                  ¿Estará facturando la discusión del plan?
                                </span>
                                <span class="data-content">
                                  {{
                                    card.planDiscussedWithParentsFlag
                                      ? "SI"
                                      : "NO"
                                  }}
                                </span>
                              </div>
                            </div>
                            <div
                              v-if="card.planProductionDate"
                              class="d-flex align-items-start flex-fill"
                            >
                              <div class="d-flex flex-column">
                                <span class="data-title">Fecha de Plan:</span>
                                <span class="data-content">
                                  {{ card.planProductionDate | dateFormat }}
                                </span>
                              </div>
                            </div>
                            <div
                              v-if="card.completeTime"
                              class="d-flex align-items-start flex-fill"
                            >
                              <div class="d-flex flex-column">
                                <span class="data-title">Hora:</span>
                                <span class="data-content ml-1 cursor-pointer">
                                  {{ card.completeTime }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div slot="actions">
                          <div class="dropdown text-right">
                            <button
                              class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <span class="px-2">Acciones</span>
                              <i class="fa fa-angle-down" />
                            </button>
                            <div
                              class="dropdown-menu dropdown-menu-right py-2 mt-1"
                            >
                              <div
                                class="dropdown-item"
                                @click="downloadDocument(documentType.id, card)"
                              >
                                <em class="fa fa-download text-green pr-1" />
                                <span>Descargar Documento</span>
                              </div>
                              <div
                                v-if="
                                  (hasReplaceDocPermission &&
                                    canReplaceDoc(card)) ||
                                    hasReferralReplaceDocPermission
                                "
                                class="dropdown-item"
                                @click="replaceDocument(card)"
                              >
                                <em class="fa fa-copy text-green pr-1" />
                                <span>Reemplazar Documento</span>
                              </div>
                              <div
                                v-if="
                                  (isInterventionPlanDoc(card) &&
                                    interventionPlanDocs.length > 1 &&
                                    canBeDeleted(card)) ||
                                    canBeDeleted(card)
                                "
                                class="dropdown-item"
                                @click="
                                  deleteDocument(
                                    card,
                                    documentType.id + documentType.name
                                  )
                                "
                              >
                                <em class="fa fa-trash text-red pr-1" />
                                <span>Eliminar Documento</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </RowCardItemCard>
                    </div>
                    <div
                      v-if="
                        !existDocumentInSummary(
                          item.yearId,
                          documentType.name,
                          documentType.id
                        )
                      "
                    >
                      <div
                        class="d-flex align-items-center justify-content-center mt-5 py-5"
                      >
                        <div class="align-items-center d-flex">
                          <i
                            class="fal big-icon mr-4 fa-folder-open text-gray-light"
                          />
                          <span class="text-gray-light message">
                            No existen documentos
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <!-- Resumen de Resultados -->
          <div v-if="resultSummary != null">
            <section-title
              :bg-icon="getBgIcon(isTypeVisible('resultSummary'))"
              class="cursor-pointer"
              :icon="getIcon(isTypeVisible('resultSummary'))"
              content="Resumen de Resultados"
              container-class="mt-2 mb-2"
              @on-click="toggleVisibility('resultSummary')"
            />
            <transition name="list">
              <div
                v-show="isTypeVisible('resultSummary')"
                class="card-body p-0 mb-4"
              >
                <div>
                  <row-card-item-card
                    status-class="gray"
                    :containerBgWhite="true"
                  >
                    <div slot="body">
                      <div class="col-12 p-0 d-flex">
                        <div class="pl-0 py-0 col-5">
                          <div class="d-flex flex-column">
                            <span class="data-title">Título:</span>
                            <span class="data-content">
                              Resumen de Resultados
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="actions">
                      <div class="dropdown text-right">
                        <button
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                          data-toggle="dropdown"
                        >
                          <span class="px-2">Acciones</span>
                          <i class="fa fa-angle-down" />
                        </button>
                        <div
                          class="dropdown-menu dropdown-menu-right py-2 mt-1"
                        >
                          <div
                            class="dropdown-item"
                            @click="downloadDocument('resultSummary', card)"
                          >
                            <em class="fa fa-download text-green pr-1" />
                            <span>Descargar Documento</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </row-card-item-card>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="d-flex align-items-center justify-content-center mt-5 py-5">
        <div class="align-items-center d-flex">
          <i class="fal big-icon mr-4 fa-folder-open text-gray-light" />
          <span class="text-gray-light message">
            No existen documentos
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/common/page/PageHeader";
import { SectionTitle } from "@/components/pei/shared";
import RowCardItemCard from "@/components/common/rowcard/RowCardItemCard";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import CustomDropDown from "@/components/common/CustomDropDown";
import CustomFileInput from "@/components/common/CustomFileInput";
import ActionButton from "@/components/common/ActionButton";
import CustomDatePicker from "@/components/common/CustomDatePicker";
import CustomTimePicker from "@/components/common/CustomTimePicker";
import CustomRadioGroup from "@/components/common/CustomRadio";
import alert from "@/mixin/alert.mixin";
import generalService from "@/services/pei/general";
import thrpyReferralService from "@/services/pei/thrpyReferrals";
import academicYearService from "@/services/academicyear";
import codeDocumentTypes from "@/utils/constants/documentTypes";
import thrpyDocumentType from "@/utils/constants/pei/referral/thrpyDocumentType";
import moment from "moment";
import DocumentTypes from "@/utils/constants/documentTypes";
const PLAN_INTERVENCION_FIRMADO = "Plan de Intervención Firmado";
const HOJA_TRAMITE_SAEE = "Hoja de Trámite (SEE-UMESR-CSEE-VC-07)";

export default {
  name: "ServiceHistoryDocuments",
  mixins: [alert],
  components: {
    PageHeader,
    RowCardItemCard,
    SectionTitle,
    ValidationProvider,
    ValidationObserver,
    CustomDropDown,
    CustomFileInput,
    ActionButton,
    CustomDatePicker,
    CustomTimePicker,
    CustomRadioGroup
  },
  data() {
    return {
      visibleTypes: [],
      allowAddDocument: false,
      showInterventions: false,
      showMinutes: false,
      showEvaluations: false,
      showOthers: false,
      addingDocument: false,
      selectedDocumentType: null,
      selectedDocument: null,
      selectedDocumentTypeIP: null,
      selectedAcademicYearIP: null,
      selectedbillingDiscussionIP: null,
      planDate: null,
      endTime: null,
      startTime: null,
      allowedFiles: ".pdf",
      documentTypes: {
        PlanDeIntervencion: { id: 844, name: "Plan de Intervención" },
        Minuta: { id: 76, name: "Minuta" },
        Evaluacion: { id: 75, name: "Evaluación" },
        CartaDeAprestacionDeRemedio: {
          id: -1,
          name: "Carta de Aprestación de Remedio"
        },
        Otros: { id: 77, name: "Otros" },
        PlanDeIntervencionRP: { id: 39, name: "Plan de Intervención" },
        InformeDeProgresoRP: { id: 40, name: "Informe de Progreso" },
        HojaDeAsistenciaRP: { id: 41, name: "Hoja de Asistencia" },
        OtrosRP: { id: 37, name: "Otros" }
      },
      documentTypeList: [
        {
          id: 75,
          name: "Evaluación"
        },
        {
          id: 76,
          name: "Minuta"
        },
        {
          id: 77,
          name: "Otros"
        }
      ],
      page: {
        icon: "fas fa-user-edit",
        title: "Ver Documentos",
        routes: ["Inicio", "PEI", "Historial de Servicios"]
      },
      documentsCounter: 0,
      documentsByType: [],
      tabToReturn: null,
      routeTitle: "",
      mainTitle: "",
      providerName: "",
      documentTypeListIP: [],
      academicYearListIP: [],
      academicYearIdList: [],
      summaryAchievements: [],
      radioButtonsOptions: [
        { label: "Si", value: true },
        { label: "No", value: false }
      ],
      isInterventionPlanSubmitted: false,
      resultSummary: false,
      achievementSummary: false,
      admissionId: 0,
      interventionPlanId: 0
    };
  },
  computed: {
    replaceableTypes() {
      const replaceableTypes = [
        thrpyDocumentType.PlanDeIntervencion,
        thrpyDocumentType.PaquetePlanAnual,
        thrpyDocumentType.Evaluacion,
        thrpyDocumentType.ThrpyEvaluacion,
        thrpyDocumentType.Minuta,
        thrpyDocumentType.ResumenResultadoDeServicios,
        thrpyDocumentType.CodeDocumentTypeResumenResultadosServicios
      ];

      return replaceableTypes;
    },
    hasDeleteDocPermission() {
      return this.$store.getters.HasPermission(
        "referredmanagement.candeletedocuments"
      );
    },
    hasReplaceDocPermission() {
      return this.$store.getters.HasPermission("pei.service.replacedocument");
    },
    hasReferralReplaceDocPermission() {
      return this.$store.getters.HasPermission("pei.referral.replacedocument");
    },
    interventionPlanDocs() {
      let result = [];
      const interventionPlan = this.documentsByType.find(
        x => x.id === thrpyDocumentType.PlanDeIntervencion
      );

      if (interventionPlan) result = interventionPlan.docs;

      return result;
    },
    selectedDocumentIpId() {
      return this.selectedDocumentTypeIP?.id ?? 0;
    },
    isForInterventionPlan() {
      return this.$route.params.servicePlan ?? false;
    },
    isBillingDiscussionPlanVisible() {
      const selectedDocumentId = this.selectedDocumentTypeIP?.id ?? 0;

      const selectedDocument =
        selectedDocumentId == codeDocumentTypes.PlanDeIntervencion ||
        selectedDocumentId == codeDocumentTypes.PaquetePlanAnual;

      return selectedDocument;
    },
    isDateAndTimeVisible() {
      const documentId = this.selectedDocumentTypeIP?.id ?? 0;
      const hasBilling = this.selectedbillingDiscussionIP ?? false;

      if (documentId === codeDocumentTypes.PlanDeIntervencion && hasBilling) {
        return true;
      }
      if (documentId === codeDocumentTypes.PlanDeEnmienda) {
        return false;
      }
      if (documentId === codeDocumentTypes.PaquetePlanAnual && hasBilling) {
        return true;
      }
      if (documentId === codeDocumentTypes.ResumenResultadoDeServicios) {
        return false;
      }
      return false;
    },
    thrpyDocumentTypesCodes() {
      return codeDocumentTypes;
    },
    notDeletableDocuments() {
      return [
        thrpyDocumentType.PlanDeIntervencion,
        thrpyDocumentType.PlanDeEnmienda,
        thrpyDocumentType.PaquetePlanAnual
      ];
    }
  },
  async mounted() {
    this.studentServiceId = this.$root.$route.params.studentServiceId;
    this.contractId = this.$root.$route.params.contractId;
    this.allowAddDocument = this.$root.$route.params.allowAddDocument;
    this.tabToReturn = this.$root.$route.params.tab;
    this.routeTitle = this.$root.$route.params.routeTitle;
    this.mainTitle = this.$root.$route.params.mainTitle;
    this.admissionId = this.$root.$route.params.admissionId;
    const servicePlan = this.$root.$route.params.servicePlan;
    this.resultSummary = this.$root.$route.params.resultSummary;
    this.achievementSummary = this.$root.$route.params.achievementSummary;
    this.isInterventionPlanSubmitted = this.$root.$route.params.isInterventionPlanSubmitted;
    this.interventionPlanId = this.$root.$route.params.interventionPlanId;

    //change last sitemap entry
    if (this.routeTitle) {
      this.page.routes.splice(this.page.routes.length - 1, 1, this.routeTitle);
    }

    //change main title
    if (this.mainTitle) {
      this.page.title = this.mainTitle;
    }

    await this.loadDocuments();

    if (servicePlan) {
      this.providerName = servicePlan.providerName;
      this.admissionId = servicePlan.admissionId;

      //load effective academic year
      if (this.admissionId) {
        this.getEffectiveAcademicYears(this.admissionId);
      }
    }
  },
  methods: {
    canReplaceDoc(doc) {
      return this.replaceableTypes.indexOf(doc.documentTypeId) !== -1;
    },
    isInterventionPlanDoc(doc) {
      return doc.documentTypeId === thrpyDocumentType.PlanDeIntervencion;
    },
    async deleteDocument(document, toggleVal) {
      const self = this;
      await thrpyReferralService
        .deleteThrpyReferralItemAttachment(document.documentId)
        .then(() => {
          this.ShowToast(
            "Proceso Exitoso",
            "El documento ha sido eliminado exitosamente.",
            "success"
          );
        })
        .catch(error => {
          if (error && error.response && error.response.data) {
            self.ShowToast("", error.response.data.message, "error");
          }
        });

      await this.loadDocuments();
      await this.toggleVisibility(toggleVal);
    },
    canDeleteInterventionPlanDoc(document) {
      let canDelete;
      if (
        !this.isInterventionPlanDoc(document) ||
        this.interventionPlanDocs.length <= 1
      ) {
        canDelete = false;
      } else {
        // JSF: can delete an intervention plan document only if it has more than 1 document for that academic year.
        const docs = this.interventionPlanDocs.filter(
          a => a.academicYearId === document.academicYearId
        );
        canDelete = docs.length > 1;
      }

      return canDelete;
    },
    canBeDeleted(document) {
      const isDeletable =
        this.notDeletableDocuments.indexOf(document.documentTypeId) === -1 ||
        this.canDeleteInterventionPlanDoc(document);

      return (
        (this.hasDeleteDocPermission || document.isUserCreator) && isDeletable
      );
    },
    setStartTime(value) {
      this.startTime = value;
    },
    setEndTime(value) {
      this.endTime = value;
    },
    async downloadDocument(documentTypeId, card) {
      if (documentTypeId == "resultSummary") {
        let report = `referral/resultsummaryreport/${this.admissionId}/${this.resultSummary}`;
        await generalService.downloadReport(report);
        return;
      }
      if (documentTypeId == "achievementSummary") {
        let report = `referral/achievementssummaryreport/${this.admissionId}/${this.interventionPlanId}`;
        await generalService.downloadReport(report);
        return;
      }
      if (
        documentTypeId == DocumentTypes.PlanDeIntervencionFirmado &&
        card.isReport
      ) {
        let report = `referral/interventionplanreport/${this.admissionId}/${this.interventionPlanId}`;
        await generalService.downloadReport(report);
        return;
      }
      if (
        documentTypeId == codeDocumentTypes.IntitialEvaluation ||
        documentTypeId == codeDocumentTypes.AdditionalEvaluation
      ) {
        await generalService.downloadDocumentByAttachmentId(card.documentId);
        return;
      }
      if (card.documentId && this.studentServiceId) {
        await generalService.downloadDocumentForThrerapyReferral(
          card.relatedRecordId
        );
      } else if (card.documentId && this.contractId) {
        await generalService.downloadDocumentForRP(card.documentId);
      }
    },
    viewDocument() {
      //TODO
    },
    getIcon(expanded) {
      return expanded ? "fas fa-chevron-down" : "fas fa-chevron-right";
    },
    getBgIcon(expanded) {
      return expanded ? "green" : "gray";
    },
    addDocument() {
      this.addingDocument = true;
    },
    cancelAddDocument() {
      this.addingDocument = false;
      this.selectedDocumentType = null;
      this.selectedDocument = null;
    },

    async saveDocument() {
      if (this.isForInterventionPlan) {
        this.saveIntervationDocument();
      } else {
        this.saveTherapyDocument();
      }
    },
    async clearOptions() {
      this.selectedAcademicYearIP = null;
      this.isDateAndTimeVisible = false;
      this.endTime = null;
      this.startTime = null;
      this.planDate = null;
      this.selectedbillingDiscussionIP = null;
      this.selectedDocument = null;
      this.selectedDocumentTypeIP = null;
      this.documentTypeListIP = [];
    },
    async saveIntervationDocument() {
      const formValid = await this.$refs.formValidator.validate();
      if (formValid) {
        let formData = new FormData();
        formData.append("attachment", this.selectedDocument);
        formData.append("fileName", this.selectedDocument.name);
        formData.append(
          "StudentServiceId",
          this.studentServiceId ? this.studentServiceId : 0
        );
        formData.append("documentTitle", this.selectedDocument.name);
        formData.append(
          "peiAttachmentTypeCode",
          this.selectedDocumentTypeIP.id
        );
        formData.append("academicYearId", this.selectedAcademicYearIP.id);
        formData.append("admissionId", this.admissionId);
        if (this.isDateAndTimeVisible) {
          formData.append(
            "PlanProductionEndTime",
            moment(this.endTime, "HH:mm:ss").format("HH:mm:ss")
          );
          formData.append(
            "PlanProductionStartTime",
            moment(this.startTime, "HH:mm:ss").format("HH:mm:ss")
          );
          formData.append(
            "PlanProductionDate",
            moment(this.planDate).format("MM/DD/YYYY")
          );
          formData.append(
            "PlanDiscussedWithParentsFlag",
            this.selectedbillingDiscussionIP
          );
        }
        let self = this;
        self
          .$ApiPost(
            "api/studentreferrals/interventionplan/savedocument/",
            formData
          )
          .then(res => {
            if (res) {
              this.ShowToast(
                "Proceso Exitoso",
                "El documento ha sido cargado exitosamente.",
                "success"
              );
              self.cancelAddDocument();
              self.loadDocuments();
              // Clear Options
              self.clearOptions();
            }
          })
          .catch(error => {
            if (error && error.response && error.response.data) {
              self.ShowToast("", error.response.data.message, "error");
            }
          });
      } else {
        this.ShowToast(
          "Error",
          "Favor de completar la información solicitada para continuar.",
          "error"
        );
      }
    },
    async replaceDocument(card) {
      const confirmation = await this.ShowCancelModal(
        "Atención",
        "¿Esta seguro que desea reemplazar el documento?",
        "Aceptar",
        "Cancelar"
      );

      if (!confirmation) return;

      const inputElement = document.createElement("input");

      inputElement.setAttribute("type", "file");
      inputElement.setAttribute("style", "visibility:hidden");
      inputElement.setAttribute("accept", "application/pdf");

      inputElement.onchange = async event => {
        const files = event.target.files;

        if (files.length === 0) return;

        const formData = new FormData();
        formData.append("File", files[0]);

        const documentTypeId = parseInt(card.documentTypeId);
        const { data: response } = await this.$ApiPost(
          `/api/thrpyadmission/replacedocument/${card.documentId}/${documentTypeId}/${card.relatedRecordId}`,
          formData
        ).catch(({ response: errors }) => {
          this.ShowToast("", errors.data.errors.errors[0], "error");
          inputElement.remove();

          return;
        });

        if (response && parseInt(response.relatedRecordId) > 0) {
          card.documentId = response.documentId;
          card.documentTitle = response.documentTitle;
          card.relatedRecordId = response.relatedRecordId;

          this.ShowToast(
            "Proceso Exitoso.",
            "La evaluación fue remplazada exitosamente.",
            "success"
          );
        }

        inputElement.remove();
      };

      document.body.appendChild(inputElement);
      inputElement.click();
    },
    async saveTherapyDocument() {
      const formValid = await this.$refs.formValidator.validate();
      if (formValid) {
        let formData = new FormData();
        formData.append("attachment", this.selectedDocument);
        formData.append("fileName", this.selectedDocument.name);
        formData.append(
          "StudentServiceId",
          this.studentServiceId ? this.studentServiceId : 0
        );
        formData.append("documentTitle", this.selectedDocument.name);
        formData.append("peiAttachmentTypeCode", this.selectedDocumentType.id);
        let self = this;
        self
          .$ApiPost(
            "api/thrpyadmission/savethrpyreferralitemattachment",
            formData
          )
          .then(res => {
            if (res) {
              this.ShowToast(
                "Proceso Exitoso",
                "El documento ha sido cargado exitosamente.",
                "success"
              );
              self.cancelAddDocument();
              self.loadDocuments();
            }
          })
          .catch(error => {
            if (error && error.response && error.response.data) {
              self.ShowToast("", error.response.data.message, "error");
            }
          });
      } else {
        this.ShowToast(
          "Error",
          "Favor de completar la información solicitada para continuar.",
          "error"
        );
      }
    },
    async loadDocuments() {
      // Función para cargar los documentos
      const fetchDocuments = async (url) => {
        try {
          const res = await this.$ApiGet(url);
          return res.data;
        } catch (err) {
          this.response = err;
          throw err;
        }
      };

      // Función para agregar Plan de Intervención Firmado si es necesario
      const addPlanDeIntervencionFirmado = (documents) => {
        if (!documents.some(x => x.documentTypeId == DocumentTypes.PlanDeIntervencionFirmado) && this.isInterventionPlanSubmitted) {
          documents.push({
            documentTypeId: DocumentTypes.PlanDeIntervencionFirmado,
            documentType: "Plan de Intervención Firmado",
            documentTitle: "InterventionPlanReport.pdf",
            isReport: true,
          });
        }
      };

      // Función para manejar los tipos de documentos
      const getDocumentTypes = (documents) => {
        const documentTypes = [];
        documents.forEach((value) => {
          const documenTypeModel = {
            id: value.documentTypeId,
            name: value.documentType,
          };

          if (!documentTypes.some(f => f.name === documenTypeModel.name) && documenTypeModel.name != null) {
            documentTypes.push(documenTypeModel);
          }
        });
        return documentTypes;
      };

      // Función para obtener los años académicos
      const getAcademicYearIds = (documents) => {
        const academicYearIdsSet = new Set();

        const hasYearId = (set, yearId) => {
          return Array.from(set).some(obj => obj.yearId === yearId);
        };

        documents.forEach((obj) => {
          if (!hasYearId(academicYearIdsSet, obj.academicYearId)) {
            academicYearIdsSet.add({
              yearId: obj.academicYearId,
              isOpen: false,
              academicYearDescription: obj.academicYearDescription,
            });
          }
        });

        return Array.from(academicYearIdsSet).sort((a, b) => b.yearId - a.yearId);
      };

      // Función para agrupar documentos por tipo
      const groupDocumentsByType = (documents, documentTypes) => {
        const groupedDocs = [];
        documentTypes.forEach((dtype) => {
          let filteredDocuments = documents.filter(d => d.documentType === dtype.name);

          // Lógica específica para Plan de Intervención y otros tipos especiales
          if (dtype.id === this.thrpyDocumentTypesCodes.PlanDeIntervencion) {
            filteredDocuments = documents.filter(d => d.documentType === dtype.name || d.documentType === PLAN_INTERVENCION_FIRMADO);
          }
          if (dtype.id === this.thrpyDocumentTypesCodes.InformeAltaBajaSAEESR06) {
            filteredDocuments = documents.filter(d => d.documentType === dtype.name || d.documentType === HOJA_TRAMITE_SAEE);
          }
          if ([this.thrpyDocumentTypesCodes.InformedeLogrosDiciembre, this.thrpyDocumentTypesCodes.InformedeLogrosMayo].includes(dtype.id)) {
            this.summaryAchievements.push({
              id: dtype.id,
              name: dtype.name,
              docs: filteredDocuments,
            });
          }

          groupedDocs.push({
            id: dtype.id,
            name: dtype.name,
            docs: filteredDocuments,
          });
        });
        return groupedDocs;
      };

      // Determinar el tipo de servicio (studentServiceId o contractId)
      let documents = [];
      if (this.studentServiceId) {
        documents = await fetchDocuments(`/api/thrpyadmission/GetDocumentsByStudentServiceId/${this.studentServiceId}`);
      } else if (this.contractId) {
        documents = await fetchDocuments(`/api/thrpyadmission/GetDocumentsByContractId/${this.contractId}`);
      } else {
        return; // Si no hay ninguno de los dos identificadores, no hace nada
      }

      // Preparar los documentos
      this.documentsByType = [];
      this.documentsCounter = 0;
      this.visibleTypes = [];
      this.summaryAchievements = [];

      // Agregar Plan de Intervención Firmado si es necesario
      addPlanDeIntervencionFirmado(documents);

      // Obtener tipos de documentos
      const documentTypes = getDocumentTypes(documents);

      // Obtener años académicos
      this.academicYearIdList = getAcademicYearIds(documents);

      // Agrupar los documentos por tipo
      this.documentTypes = documentTypes;
      const groupedDocs = groupDocumentsByType(documents, documentTypes);

      // Filtrar y ordenar los documentos
      this.documentsByType = groupedDocs.filter(item => item.name !== PLAN_INTERVENCION_FIRMADO && item.name !== HOJA_TRAMITE_SAEE);
      this.documentsByType.sort((a, b) => a.name.localeCompare(b.name));

      // Contar los documentos
      this.documentsCounter = documents.length * this.academicYearIdList.length;

      return documents;
    },
    goToPage(page) {
      this.pagination.currentPage = page;
    },
    goBack() {
      if (this.tabToReturn) {
        this.$router.push(
          "/pei/ServiceHistory" +
            (this.tabToReturn ? "?tab=" + this.tabToReturn : "")
        );
      } else {
        this.$router.go(-1);
      }
    },
    toggleVisibility(val) {
      let idx = this.visibleTypes.indexOf(val);
      if (idx >= 0) {
        this.visibleTypes.splice(idx, 1);
      } else {
        this.visibleTypes.push(val);
      }
    },
    isTypeVisible(id) {
      return this.visibleTypes.indexOf(id) >= 0;
    },
    onChangeAcademicYearIP(selected) {
      this.documentTypeListIP = [];
      this.selectedDocumentTypeIP = null;
      if (selected) {
        this.getValidDocumentTypes(this.studentServiceId, selected.id);
      }
    },
    existDocument(yearId, name, id) {
      for (const item of this.documentsByType) {
        if (id == this.thrpyDocumentTypesCodes.InformeAltaBajaSAEESR06) {
          if (
            item.docs.some(
              doc =>
                (doc.documentType == name ||
                  doc.documentType == HOJA_TRAMITE_SAEE) &&
                doc.academicYearId === yearId
            )
          ) {
            return true;
          }
        }
        if (id == this.thrpyDocumentTypesCodes.PlanDeIntervencion) {
          if (
            item.docs.some(
              doc =>
                (doc.documentType == name ||
                  doc.documentType == PLAN_INTERVENCION_FIRMADO) &&
                doc.academicYearId === yearId
            )
          ) {
            return true;
          }
        }
        if (
          item.docs.some(
            doc => doc.documentType == name && doc.academicYearId === yearId
          )
        ) {
          return true;
        }
      }
      return false;
    },
    existDocumentInSummary(yearId, name, id) {
      for (const item of this.summaryAchievements) {
        if (id == this.thrpyDocumentTypesCodes.InformeAltaBajaSAEESR06) {
          if (
            item.docs.some(
              doc =>
                (doc.documentType == name ||
                  doc.documentType == HOJA_TRAMITE_SAEE) &&
                doc.academicYearId === yearId
            )
          ) {
            return true;
          }
        }
        if (id == this.thrpyDocumentTypesCodes.PlanDeIntervencion) {
          if (
            item.docs.some(
              doc =>
                (doc.documentType == name ||
                  doc.documentType == PLAN_INTERVENCION_FIRMADO) &&
                doc.academicYearId === yearId
            )
          ) {
            return true;
          }
        }
        if (
          item.docs.some(
            doc => doc.documentType == name && doc.academicYearId === yearId
          )
        ) {
          return true;
        }
      }
      return false;
    },
    onChangeDocumentIP() {
      this.selectedbillingDiscussionIP = null;
    },
    onSelectedBillingDisussionPlan() {},
    async getEffectiveAcademicYears(admissionId) {
      const {
        data: response
      } = await academicYearService.getEffectiveAcademyYears(admissionId);
      if (response) {
        this.academicYearListIP = response;
      }
    },
    async getValidDocumentTypes(studentServiceId, academicYearId) {
      if (studentServiceId && academicYearId) {
        const response = await thrpyReferralService.getValidDocumentTypes(
          studentServiceId,
          academicYearId
        );
        if (response) {
          this.documentTypeListIP = response;
          this.selectedbillingDiscussionIP = null;
        }
      }
    }
  }
};
</script>

<style scoped>
.gray-box {
  border-radius: 5px;
  background-color: #f7f7f7;
}
.buttons-container {
  margin-top: 29px;
}
.message {
  font-size: 16px;
}
.big-icon {
  font-size: 3em;
}
.btn-dropdown-actions i.fa-angle-down {
  font-size: 12px;
  font-weight: 400;
}
.btn-dropdown-actions::after {
  border: none;
}
.dropdown-item {
  cursor: pointer;
  padding: 0.25rem 1rem;
  font-size: 15px;
}
.dropdown-item span {
  margin-left: 10px;
}
.dropdown-item em {
  min-width: 23px;
}
.list-enter,
.list-leave-to {
  display: none;
  height: 0;
}

.list-enter-active,
.list-leave-active {
  transition: height 0.35s ease;
}

.billing-text-label {
  text-align: left;
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0px;
  color: #11291b;
}

.billing-text-span {
  text-align: left;
  font-size: 0.9rem;
  letter-spacing: 0px;
  color: #11291b;
}
.custom-design {
  font-size: 25px;
  padding: 2px;
}
.color-icon-plus {
  color: #3f5b60 !important;
}
.container-design {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
}
</style>
